import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface DebugContextType {
  debug: boolean;
}

const DebugContext = createContext<DebugContextType | undefined>(undefined);

interface DebugProviderProps {
  children: ReactNode;
}

export const DebugProvider: React.FC<DebugProviderProps> = ({ children }) => {
  const [debug, setDebug] = useState<boolean>(false);

  useEffect(() => {
    // Check if debug parameter exists in URL
    const urlParams = new URLSearchParams(window.location.search);
    const debugParam = urlParams.has('debug');
    setDebug(debugParam);

    // Optional: Log debug mode status
    if (debugParam) {
      console.log('Debug mode enabled');
    }
  }, []);

  return (
    <DebugContext.Provider value={{ debug }}>
      {children}
    </DebugContext.Provider>
  );
};

export const useDebug = (): boolean => {
  const context = useContext(DebugContext);
  if (context === undefined) {
    throw new Error('useDebug must be used within a DebugProvider');
  }
  return context.debug;
};
